import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CouponListRes;
export const CouponListTodo = createAsyncThunk('CouponList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'coupon_discount',
            params: {
                "user_id": localStorage.getItem('user_id'),
                "coupon_status ": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CouponListRes = res.data

    } catch (error) {
        return CouponListRes = error.response.data
    }
})

const CouponListSlice = createSlice({
    name: 'CouponList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CouponListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(CouponListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CouponListSlice.reducer; 